{
  "GENERAL": {
    "CLOSE": "Fermer",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Rechercher",
      "EMPTY_STATE": "Aucun résultat trouvé"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Au moins {count} requis"
  }
}
